import { constants } from 'lib_ui-services';
import { BbState } from 'lib_ui-primitives';
import getAllFeatureFlags from '../../../../utilities/getAllFeatureFlags';

/**
 *  * Selection Retention:
 *  Scope: Local, PerRoute, Global
 *  Visibility: PerBrowser (later: PerUser, PerTenant)
 *  Duration: Request, Session, Always
 * @type {import('lib_ui-services/src/constants/retention').Retention}
 */
const { SCOPE, VISIBILITY, DURATION } = constants.retention;

export default {
    verb: 'doingGet',
    namespace: 'identity',
    relation: 'userRole',
    priority: 10,
    description: "Get the user user's role",
    logic: doingGet
};

export const _private = { BbState };

async function doingGet({ data = {}, context }) {
    const { role: basicRole } = context?.session || {};
    //can't put this in the top level, as we need to return "something"
    const clientDataRights = getAllFeatureFlags(context).includes('clientDataRights') ?? false;
    if (!clientDataRights) {
        return { ...data, result: [basicRole] };
    }

    const roleRetention = {
        // DURATION.PAGE_LOAD/VISIBILITY.PER_BROWSER: this value gets cleared on page reload or login/out
        duration: DURATION.PAGE_LOAD,
        visibility: VISIBILITY.PER_BROWSER,
        scope: SCOPE.LOCAL,
        // the only reason we might not have an _id would be when running unit tests
        id: basicRole?._id || 'test'
    };

    const bbState = _private.BbState.connect(roleRetention);
    const role = await bbState.getAsync('role');
    return { ...data, result: [role] };
}
